import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'appkit-react';
import './toast.scss';

const IndividualToast = ({ contentStyles = {}, isShow = false, content }) =>
  isShow ? (
    <div className="toast-box">
      <div className="content-box">
        <div className="content" style={contentStyles}>
          {content ? (
            content
          ) : (
            <React.Fragment>
              <div className="title">Questionnaire Completed</div>
              <div>
                Thank you for completing all the sections of the questions.
                Please review your responses and submit once you are happy to
                proceed. The Questionnaire will provide us with an overview of
                Financial and Operations with a series of cross functional
                underneath them that help to understand business performance,
                regulatory requirements, and how entangled it is with rest of
                the company.
              </div>
              <Button size="xl">REVIEW REPONSES</Button>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  ) : null;
IndividualToast.propTypes = {
  contentStyles: PropTypes.object,
  isShow: PropTypes.bool,
  content: PropTypes.any,
};
export default IndividualToast;
